<template>
    <v-card flat tile :to="`/artists/${author._id}`">
        <v-img :src="author?.thumb?.url" :aspect-ratio="1 / 1" width="100%" :class="{ 'v-sheet--outlined': !author?.thumb?.url }">
            <template #placeholder>
                <v-overlay absolute dark color="transparent">
                    <v-icon color="grey" size="40">mdi-account</v-icon>
                </v-overlay>
            </template>
        </v-img>
        <v-card-title>{{ author?.name?.ko }}</v-card-title>
        <v-divider class="primary" />
    </v-card>
</template>

<script>
import { initAuctionAuthor } from "@/assets/inits";
export default {
    props: {
        author: { type: Object, default: initAuctionAuthor },
    },
};
</script>

<style lang="scss" scoped>
.v-card__title {
    color: #1a1a1a;
    font-size: 24px;
    font-family: var(--font-notoserif);
    padding: 20px 0;
}
@media (min-width: 768px) {
    .v-card__title {
        font-size: 18px;
    }
}
@media (min-width: 1024px) {
    .v-card__title {
        font-size: 24px;
    }
}
</style>
